// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"4983ec9f","179":"387eda3a","213":"0c8f1caa","219":"bb80e489","445":"94e0fa27","453":"d1fa110c","534":"38b4c643","547":"29872215","624":"fae751de","676":"ee7a330b","732":"74d40df9","824":"6c721a7a","955":"9fc1950d"}[chunkId] + ".chunk.js";
};